import { TableCell } from '@mui/material';
import moneyFormat from '../functions/moneyFormat';
import rateFormat from '../functions/rateFormat';

// row for the program adjustment table. Rows flagged with isSummary (totals) are displayed in bold
// and boxed with the primary color (first summary row: top border, last summary row: bottom border)
const ProgramAdjustmentRow = ({ row, count, tableHeader, rateTypeId = 0, stickyEnabled }) => {
    const boxBorder = '2px solid ' + process.env.REACT_APP_PRIMARY_COLOR; 

    const getCellSx = (index) => {
        if (!row['isSummary']) {
            return {}; 
        }
        return {
            fontWeight: 'bold', 
            ...(row['isFirstSummary'] && { borderTop: boxBorder }), 
            ...(row['isLastSummary'] && { borderBottom: boxBorder }), 
            ...(index === 0 && { borderLeft: boxBorder }), 
            ...(index === tableHeader.length - 1 && { borderRight: boxBorder }), 
        }; 
    }

    const getRowClassName = (columnOrder) => {
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder === 0 ? "table-cell-sticky-row" : ""; 
    }

    return (
        <>
            {tableHeader.map((el, index) =>
                el['format'] == 'money' ?
                    <TableCell className={getRowClassName(el['columnorder'])} sx={getCellSx(index)} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>
                : el['format'] == 'rate' ?
                    // summary rows have no rate
                    row['isSummary'] ?
                        <TableCell className={getRowClassName(el['columnorder'])} sx={getCellSx(index)} align='right'></TableCell>
                    : row[el['columnname']] == null ?
                        <TableCell className={getRowClassName(el['columnorder'])} sx={getCellSx(index)} align='right'>None</TableCell>
                    : <TableCell className={getRowClassName(el['columnorder'])} sx={getCellSx(index)} align='right'>{rateFormat(row[el['columnname']], rateTypeId)}</TableCell>
                : row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])} sx={getCellSx(index)}>None</TableCell>
                : <TableCell className={getRowClassName(el['columnorder'])} sx={getCellSx(index)}>{row[el['columnname']]}</TableCell>
            )}
        </>
    ); 
}

export default ProgramAdjustmentRow; 
